import { Collection, Select, TextInput, Table, NumberInput, MultilineInput, Tabs } from "@tblabs/truffle";
import { Box } from "../../../../Components/Utils/Box";
import { DateTimeEditInput } from "../../../../Components/Utils/DateSlider";
import { Icons } from "../../../../Components/Utils/Icons";
import { TabsV2 } from "../../../../Components/Utils/Tabs";
import { XPrimaryButton } from "../../../../Components/Utils/XPrimaryButton";
import { PaymentFormLabels } from "../../../../Models/Payment/PaymentForm";
import { PaymentStepStateLabels } from "../../../../Steps/Payment/Models/PaymentStepState";
import { PaymentReturnStep } from "../../../../Steps/Payment/PaymentReturnStep";
import { PaymentStep } from "../../../../Steps/Payment/PaymentStep";
import { BitcoinPriceProvider } from "../../../../Steps/Payment/Services/BitcoinPriceProvider";
import { Step } from "../../../../Steps/Step/Step";
import { TimeUtils } from "../../../../Utils/TimeUtils";
import { Entry } from "./Entry";
import { FormPrinter } from "../../../../Components/FormPrinter";
import { FormRow } from "../../../../Components/FormRow";


export class PaymentEntryEditBox extends Entry<Step<any>>
{
    constructor(step: PaymentStep | PaymentReturnStep, steps: Collection<Step<any>>)
    {
        super(step, steps, []);
        // this.SetTitle(step.GetFullTitle(), step.Data.State.value + ", do " + TimeUtils.FormattedDateTime(step.Timeout));
        this.SetTitle(step.GetFullTitle(), step.GetStateName());

        this.AddInput("Stan", new Select(step.Data.State, PaymentStepStateLabels));
        this.AddInput("Forma płatności", new Select(step.Data.Form, PaymentFormLabels));
        this.AddInput("Numer konta", new TextInput(step.Data.AccountNumber));

        this.Content.Append(
            new Tabs()
                .Add("Dane do przelewu", () => new FormPrinter(
                    new FormRow("Tytułem", new TextInput(step.Data.Title)),
                    new FormRow("Kwota", new NumberInput(step.Data.Amount).Step(10).Min(0)),
                    new FormRow("Waluta", new TextInput(step.Data.Currency)),
                    new FormRow("Płatne do", new DateTimeEditInput(step.Data.Deadline)),
                    new FormRow("Data wpłaty", new DateTimeEditInput(step.Data.WhenPaid)),
                ))
                .Add("Kryptowaluta", () => new FormPrinter(
                    new FormRow("Kurs BTC", new NumberInput(step.Data.ExchangeRate).Step(0.000001).Min(0)),
                    new FormRow("", new XPrimaryButton("Pobierz kurs BTC", Icons.Plus, async () =>
                    {
                        const bitcoinPriceProvider = new BitcoinPriceProvider();
                            await bitcoinPriceProvider.Update();
                            step.Data.ExchangeRate.value = bitcoinPriceProvider.BtcValueInPln.value;
                        }))
                    ))
                .Add("Szczegóły", () => new FormPrinter(
                    new FormRow("Powód anulowania", new MultilineInput(step.Data.CancellationReason).Rows(4).Placeholder("Powód")),
                    new FormRow("Komentarz", new MultilineInput(step.Data.Comment).Rows(4).Placeholder("Komentarz")),
                ))
        );
    }
}
